<script>
  /* global Global */
  export let lang = undefined;

  const i18n = {
    logosAndTrademarks: {
      cs: 'Všechna loga a obchodní značky jsou majetkem příslušných vlastníků.',
      en: 'All logos and trademarks are the property of their respective owners.',
    },
    commentsAndTheRest: {
      cs: 'Komentáře jsou majetkem jejich odesílatelů. Zbytek © ČBA.',
      en: 'Comments are the property of their posters. The rest © CBA.',
    },
    websiteUseAndPrivacyPolicy: {
      cs: 'Zásady používání webu a ochrany osobních údajů.',
      en: 'Website Use and Privacy Policy.',
    },
  };

  const projectStyle = Global.project.style;
  const contactLogo = Global.contact.logo;
  const contactName = Global.contact.name;
  const contactAdress = Global.contact.adress;
  const contactEmail = Global.contact.email;
  const contactPhone = Global.contact.phone;
</script>

<footer class:footer-sharp={projectStyle === 'sharp'}>
  <div class='footer'>
    <div class='footer-left'>
      <div class='footer-left-image'>
        <img src='img/static/logo/{contactLogo}.svg' alt='{contactName[lang]} logo'/>
      </div>

      <div class='footer-left-text'>
        <div class='footer-left-text-name'> {contactName[lang]} </div>
        {#if contactAdress[lang]}
          <div class='footer-left-text-adress'> {contactAdress[lang]} </div>
          <div class='footer-left-text-contact'>
            <div class='footer-left-text-contact-email'><a href='mailto:{contactEmail}'>{contactEmail}</a></div>
            <div class='footer-left-text-contact-phone'>, <a href='tel:{contactPhone}'>{contactPhone}</a></div>
          </div>
        {:else}
          <div class='footer-left-text-email'><a href='mailto:{contactEmail}'>{contactEmail}</a></div>
          <div class='footer-left-text-phone'><a href='tel:{contactPhone}'>{contactPhone}</a></div>
        {/if}
      </div>
    </div>

    <div class='footer-right'>
      <div class='footer-right-text'>
        <div class='footer-right-text-logos-and-trademarks'> {i18n.logosAndTrademarks[lang]} </div>
        <div class='footer-right-text-comments-and-the-rest'> {i18n.commentsAndTheRest[lang]} </div>
        <div class='footer-right-text-website-use-and-privacy-policy'>
          <a href='https://www.baseball.cz/text-134/Zasady-pouzivani-webu-a-ochrany-osobnich-udaju'> {i18n.websiteUseAndPrivacyPolicy[lang]} </a>
        </div>
      </div>
    </div>
  </div>
</footer>

<style>
  footer {
    display: flex;
    align-items: center;

    width: calc(100% - 120px);
    height: 100px;

    padding: 0px 60px;

    background: var(--primary);
    color: var(--white);
  }

  .footer-sharp {
    background: var(--grey-1);
    color: var(--black);
  }

  .footer {
    display: flex;
    justify-content: space-between;

    width: 1450px;

    margin: auto;
  }

  .footer-left {
    display: flex;
    justify-content: flex-start;
    gap: 20px;
  }

  .footer-left-image img {
    width: 57.6px;
    height: 57.6px;
  }

  .footer-left-text a {
    display: inline-block;

    text-decoration: underline;
    text-decoration-thickness: 1.5px;
    text-decoration-color: transparent;

    color: var(--white);

    transition: text-decoration-color 0.25s ease-in-out;
  }

  .footer-sharp .footer-left-text a {
    color: var(--black);
  }

  .footer-left-text a:hover {
    text-decoration-color: var(--white);
  }

  .footer-sharp .footer-left-text a:hover {
    text-decoration-color: var(--black);
  }

  .footer-left-text-contact {
    display: flex;
  }

  .footer-right {
    text-align: right;
  }

  .footer-right-text a {
    display: inline-block;

    text-decoration: underline;
    text-decoration-thickness: 1.5px;
    text-decoration-color: transparent;

    color: var(--white);

    transition: text-decoration-color 0.25s ease-in-out;
  }

  .footer-sharp .footer-right-text a {
    color: var(--black);
  }

  .footer-right-text a:hover {
    text-decoration-color: var(--white);
  }

  .footer-sharp .footer-right-text a:hover {
    text-decoration-color: var(--black);
  }

  :global(body.dark) footer {
    background: var(--primary-dark);
    color: var(--grey-3);
  }

  :global(body.dark) .footer-sharp {
    background: var(--grey-8);
  }

  :global(body.dark) .footer-left-image img {
    filter: brightness(88%);
  }

  :global(body.dark) .footer-left-text a {
    color: var(--grey-3);
  }

  :global(body.dark) .footer-left-text a:hover {
    text-decoration-color: var(--grey-3);
  }

  :global(body.dark) .footer-right-text a {
    color: var(--grey-3);
  }

  :global(body.dark) .footer-right-text a:hover {
    text-decoration-color: var(--grey-3);
  }

  @media only screen and (max-width: 1100px) {
    footer {
      width: calc(100% - 40px);

      padding: 0px 20px;
    }

    .footer {
      justify-content: center;
    }

    .footer-right {
      display: none;
    }
  }

  @media only screen and (max-width: 500px) {
    .footer-left-text-contact-phone {
      display: none;
    }
  }
</style>
